import * as Keycloak from 'keycloak-js';
import { storeInstance as Store } from '@/store';

const urlOpenID = process.env.VUE_APP_KEYCLOAK_URL
  ? process.env.VUE_APP_KEYCLOAK_URL
  : null;
const realm = process.env.VUE_APP_KEYCLOAK_REALM
  ? process.env.VUE_APP_KEYCLOAK_REALM
  : null;
const clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID
  ? process.env.VUE_APP_KEYCLOAK_CLIENTID
  : null;
const onLoad = 'check-sso';
const responseMode = 'query';
const responseType = 'code';
const flow = 'standard';

const initOptions = {
  url: urlOpenID,
  realm: realm,
  clientId: clientId,
  onLoad: onLoad,
  checkLoginIframe: true,
  responseMode: responseMode,
  responseType: responseType,
  flow: flow
};

const keyIsExternal = '/ExternalUser';

const isDebugMode = Store.getters['NGUD/isDebugMode'];

let refreshTokenGlobal = null;
let keycloak = Keycloak(initOptions);

const isMunicipioMode = typeof window !== 'undefined' &&
  window.location &&
  window.location.href.indexOf('IdMunicipio') !== -1;

export async function init () {
  if (isMunicipioMode) return true;

  if (!urlOpenID || !realm || !clientId) {
    throw new Error('Config null mandatory parameters.');
  }
  let initUser = await keycloak
    .init({ checkLoginIframe: false })
    .then(() => {
      return true;
    })
    .catch(() => {
      return false;
    });
  return initUser;
}

export async function setData () {
  if (isMunicipioMode) {
    let tokenUser = {
      nameid: null,
      role: ['Ciudadano'],
      email: null,
      given_name: null,
      family_name: null,
      aud: null,
      isExternal: false
    };
    Store.commit('NGUD/setUser', tokenUser);
    Store.commit('NGUD/authSuccess');
    return;
  }

  let tokenInfo = keycloak.tokenParsed;
  let isAuth = isAuthorized(tokenInfo);

  let tokenUser = setUser(tokenInfo);
  // Seteamos la Información del Usuario
  Store.commit('NGUD/setUser', tokenUser);

  if (!isAuth) return Store.commit('NGUD/authError');
  Store.commit('NGUD/authSuccess');

  // Iniciamos el refresco del token
  if (refreshTokenGlobal !== null) return;
  refreshToken();
}

export function login () {
  keycloak.login();
}

export function logout () {
  keycloak.logout();
  Store.commit('NGUD/clearDataUser');
}

export function goAccountURL () {
  keycloak.accountManagement();
}

export const authenticated = () => isMunicipioMode ? true : keycloak.authenticated;

export const token = () => isMunicipioMode ? '' : 'Bearer ' + keycloak.token;

export const _isMunicipioMode = () => isMunicipioMode;

export function isAuthorized (token = null) {
  let roles = token.resource_access ? token.resource_access : null;
  if (roles === null) return false;

  let userRoles = getrolUser(roles);
  return userRoles.length > 0;
}

// Private function
function refreshToken () {
  // Token Refresh
  refreshTokenGlobal = setInterval(() => {
    keycloak
      .updateToken(70)
      .then(refreshed => {
        if (refreshed) {
          if (isDebugMode) console.log('Token refreshed ' + refreshed);
        } else {
          /* if (isDebugMode) {
            console.log(
              'Token not refreshed, valid for ' +
                Math.round(
                  keycloak.tokenParsed.exp +
                    keycloak.timeSkew -
                    new Date().getTime() / 1000
                ) +
                ' seconds'
            );
          } */
        }
      })
      .catch(() => {
        if (isDebugMode) console.log('Failed to refresh token');
      });
  }, 6000);
}

function setUser (d) {
  let roles = getrolUser(d.resource_access);
  let isExternal = getTypeUser(d.groups);

  let arrayData = {
    nameid: d.sub,
    role: roles,
    email: d.email,
    given_name: d.given_name,
    family_name: d.family_name,
    aud: d.aud,
    isExternal: isExternal
  };

  return arrayData;
}

function getrolUser (resourceAccess) {
  let rolUser = [];

  Object.keys(resourceAccess).forEach(key => {
    if (key === clientId) {
      resourceAccess[key].roles.forEach(item => {
        if (item.startsWith(clientId)) {
          let stringSplit = item.split('_');
          rolUser.push(
            stringSplit[1].charAt(0).toUpperCase() + stringSplit[1].slice(1)
          );
        }
      });
    }
  });

  return rolUser;
}

function getTypeUser (d) {
  let exist = false;
  d.includes(keyIsExternal) ? (exist = true) : (exist = false);
  return exist;
}
// End Private function
